import React from "react";
import Skeleton from "./Skeleton";

const LeftSideBarComponentSkeleteon = () => {
  return (
    <div className="flex p-2 mx-4 my-2">
      <Skeleton classes={"w-12 h-12 rounded-full"} />
      <div className="pl-3 pt-2">
        <Skeleton classes={"w-20 h-3 rounded-lg mb-2"} />
        <Skeleton classes={"w-28 h-3 rounded-lg"} />
      </div>
    </div>
  );
};

export default LeftSideBarComponentSkeleteon;
